var _a;
import { ToolEnum } from './tool.enum';
export var ToolIcons = (_a = {},
    _a[ToolEnum.Select] = 'mouse-pointer',
    _a[ToolEnum.Hide] = 'eye-slash',
    _a[ToolEnum.Paint] = 'fill-drip',
    _a[ToolEnum.Label] = 'tag',
    _a[ToolEnum.Isolate] = 'hand-point-up',
    _a[ToolEnum.Fade] = 'lungs',
    _a[ToolEnum.Position] = 'location-arrow',
    _a);
